/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var WorkerJobStatus;
(function (WorkerJobStatus) {
    WorkerJobStatus["Created"] = "CREATED";
    WorkerJobStatus["Failed"] = "FAILED";
    WorkerJobStatus["Finished"] = "FINISHED";
    WorkerJobStatus["InProgress"] = "IN PROGRESS";
    WorkerJobStatus["Terminated"] = "TERMINATED";
})(WorkerJobStatus || (WorkerJobStatus = {}));
export function WorkerJobStatusFromJSON(json) {
    return WorkerJobStatusFromJSONTyped(json, false);
}
export function WorkerJobStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function WorkerJobStatusToJSON(value) {
    return value;
}
